import './SubNav-88128e5c.css';

var styles = {"SubNav":"prc-SubNav-SubNav-rjui0","Body":"prc-SubNav-Body-Nw122","Actions":"prc-SubNav-Actions--IUp-","Link":"prc-SubNav-Link-X843-","Links":"prc-SubNav-Links-5Qn65"};

export { styles as default };
